import YoutubeVideo from "../videoRendering/youtubeVideoRendering";

const videos = [
    {
        title: "Check Out What Doctors have to say about Sacrum 3D's Casts",
        description: "",
        videoId: "oMaxRaaVQ0s",
    },
    {
        title: "Check Out What Our Patients have to say about Sacrum 3D's Casts",
        description: "",
        videoId: "adVeH0E_kPI",
    }
];

const VideoSection = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid gap-14 lg:gap-20">
          {videos.map((video, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center"
            >
              {/* Heading */}
              <h2
                className="
                  text-primary font-semibold leading-tight
                  text-[1.6rem]
                  sm:text-[2.1rem]
                  md:text-[2.5rem]
                  lg:text-[2.8rem]
                  xl:text-[3rem]
                  mb-3
                "
              >
                {video.title}
              </h2>

              {/* Description */}
              <p className="max-w-2xl text-gray-500 mb-8">
                {video.description}
              </p>

              {/* 🎥 Video Card */}
              <div className="w-full max-w-4xl relative group">
                <div className="absolute -inset-1 rounded-2xl bg-gradient-to-r from-primary to-secondary opacity-30 blur transition group-hover:opacity-50" />
                <div className="relative rounded-2xl overflow-hidden border border-primary/20 bg-background shadow-xl">
                  <YoutubeVideo videoId={video.videoId} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
